/* globals app_config: true, FB: true */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import $ from 'jquery';
import {
  ShareButtons,
  generateShareIcon,
} from 'react-share';
import '@fancyapps/fancybox';

import blockDefinition from './definitions/image.json';
import BlockComponent from './BlockComponent';
import Partials from '../partials';

const {
  TwitterShareButton,
} = ShareButtons;

const FacebookIcon = generateShareIcon('facebook');
const TwitterIcon = generateShareIcon('twitter');

const propTypes = {
    picture: PropTypes.object,
    downloadable: PropTypes.bool,
    lightbox: PropTypes.bool,
    className: PropTypes.string,
    dataAttributes: PropTypes.object,
    fancyboxSelector: PropTypes.string,
};

const defaultProps = {
    picture: {
        url: '/img/placeholders/mom.jpg',
    },
    downloadable: true,
    lightbox: true,
    className: null,
    dataAttributes: null,
    fancyboxSelector: '.block-image > a, .block-media > a',
};

class ImageBlock extends BlockComponent {

    constructor(props) {
        super(props);

        this.link = null;
        this.fancybox = null;
        this.onClickImage = this.onClickImage.bind(this);
        this.onClickDownloadHigh = this.onClickDownloadHigh.bind(this);
        this.onClickDownloadPdf = this.onClickDownloadPdf.bind(this);
        this.onFancyboxBeforeShow = this.onFancyboxBeforeShow.bind(this);
        this.onClickShare = this.onClickShare.bind(this);
        this.onClickCloseShare = this.onClickCloseShare.bind(this);
        this.onClickDownload = this.onClickDownload.bind(this);
        this.onClickShareFacebook = this.onClickShareFacebook.bind(this);

        this.state = {
            shareOpened: false,
        };
    }

    componentWillUnmount() {
        if (this.fancybox !== null) {
            this.fancybox.close();
        }
    }

    // eslint-disable-next-line class-methods-use-this
    onClickImage(e) {
        const { picture, fancyboxSelector } = this.props;

        e.preventDefault();

        const $medias = $(fancyboxSelector);
        const index = $medias.index($(this.link));
        this.fancybox = $.fancybox.open($medias, {
            beforeShow: this.onFancyboxBeforeShow,
        });
        this.fancybox.jumpTo(index);

        const imageUrl = picture !== null ? picture.url : '';
        ga('send', 'event', 'Media', 'view', imageUrl);
    }

    onFancyboxBeforeShow(instance, current) {
        const { downloadable } = this.props;

        const $downloadButtons = $('.fancybox-download');

        $downloadButtons.off('click');
        if (downloadable !== null && !downloadable) {
            $downloadButtons.hide();
            return;
        }

        const $medias = $('.block-image a, .block-media a');
        const $block = $medias.eq(current.index).parents('.block').eq(0);
        if ($block.length) {
            const $blockElement = $block.find('>div').eq(0);
            const image = $blockElement.data('image');
            const pdf = $blockElement.data('pdf');
            if (image) {
                $('.fancybox-download.img').attr('href', image).show();
                $('.fancybox-download.img').on('click', this.onClickDownloadHigh);
            } else {
                $('.fancybox-download.img').hide();
            }
            if (pdf) {
                $('.fancybox-download.pdf').attr('href', pdf).show();
                $('.fancybox-download.pdf').on('click', this.onClickDownloadPdf);
            } else {
                $('.fancybox-download.pdf').hide();
            }
        } else {
            $('.fancybox-download').hide();
        }
    }

    onClickDownloadHigh() {
        const { picture } = this.props;
        const imageUrl = picture !== null ? picture.url : '';
        ga('send', 'event', 'Media', 'download', `HIGH: ${imageUrl}`);
    }

    onClickDownloadPdf() {
        const { picture } = this.props;
        const imageUrl = picture !== null ? picture.url : '';
        ga('send', 'event', 'Media', 'download', `PDF: ${imageUrl}`);
    }

    onClickDownload() {
        const { picture, dataAttributes } = this.props;
        const imageUrl = picture !== null ? picture.url : null;
        const picturesDownloadUrl = dataAttributes !== null && typeof dataAttributes['data-pictures'] !== 'undefined'
            ? dataAttributes['data-pictures'] : imageUrl;
        const pdfDownloadUrl = dataAttributes !== null && typeof dataAttributes['data-pdf'] !== 'undefined'
            ? dataAttributes['data-pdf'] : null;
        const downloadUrl = pdfDownloadUrl || picturesDownloadUrl;

        ga('send', 'event', 'Media', 'download', `PDF: ${downloadUrl}`);
    }

    onClickShare() {
        this.setState({
            shareOpened: true,
        });
    }

    onClickCloseShare() {
        this.setState({
            shareOpened: false,
        });
    }

    // eslint-disable-next-line class-methods-use-this
    onClickShareFacebook(e, share) {
        e.preventDefault();
        FB.ui({
            method: 'feed',
            picture: share.picture,
            source: share.picture,
        }, () => {
            ga('send', 'social', 'Facebook', 'post', share.url);
        });
    }

    renderShare() {
        const {
            picture,
            dataAttributes,
            rounded,
        } = this.props;
        const url = window.location.href;
        const title = 'I Am Still Your Child';
        const description = 'Jessy, Sarah and Von are all familiar with the "ups and downs" of living with a parent who suffers from mental illness. This situation is extremely common and there can be serious long-term repercussions. I Am Still Your Child immerses us in a bewildering yet hopeful world through the stories of three compelling subjects who have found ways to cope — and even thrive!';
        const imageUrl = picture !== null ? picture.url : null;
        const pictureUrl = dataAttributes !== null && typeof dataAttributes['data-pictures'] !== 'undefined'
            ? dataAttributes['data-pictures'] : imageUrl;

        const className = classNames({
            share: true,
            rounded,
        });

        const onClickShareFacebook = (e) => {
            const share = {
                title,
                description,
                url,
                picture: pictureUrl,
            };
            this.onClickShareFacebook(e, share);
        };

        const facebookUrl = `https://www.facebook.com/dialog/feed?app_id=${app_config('facebook_app_id')}&display=popup&caption=${encodeURIComponent(title)}&link=${encodeURIComponent(url)}&source=${encodeURIComponent(pictureUrl)}&redirect_uri=${window.location.href}`;

        return (
            <div className={className}>
                <button type="button" className="close" onClick={this.onClickCloseShare}>
                    <span className="fa fa-close" />
                </button>
                <div className="inner">
                    <div className="middle">
                        <a
                            href={facebookUrl}
                            onClick={onClickShareFacebook}
                            target="_blank"
                        >
                            <FacebookIcon size={64} />
                        </a>
                        <TwitterShareButton
                            title={title}
                            description={description}
                            url={pictureUrl}
                        >
                            <TwitterIcon size={64} />
                        </TwitterShareButton>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const {
            picture,
            lightbox,
            className,
            dataAttributes,
            downloadable,
            ...props
        } = this.props;

        const { shareOpened } = this.state;

        const image = (
            <Partials.Image
                media={picture}
                {...props}
            />
        );
        const blockClassName = classNames({
            'block-image': true,
            [className]: className !== null,
        });
        const imageUrl = picture !== null ? picture.url : null;
        const picturesDownloadUrl = dataAttributes !== null && typeof dataAttributes['data-pictures'] !== 'undefined'
            ? dataAttributes['data-pictures'] : imageUrl;
        const pdfDownloadUrl = dataAttributes !== null && typeof dataAttributes['data-pdf'] !== 'undefined'
            ? dataAttributes['data-pdf'] : null;
        const downloadUrl = pdfDownloadUrl || picturesDownloadUrl;
        return (
            <div
                className={blockClassName}
                data-image={imageUrl}
                {...dataAttributes}
            >
                { picture !== null && lightbox ? (
                    <a
                        href={picturesDownloadUrl}
                        className="link"
                        ref={(ref) => { this.link = ref; }}
                        onClick={this.onClickImage}
                    >
                        { image }
                    </a>
                ) : image }

                { lightbox ? (
                    <div className="toolbar">
                        { (downloadable === null || downloadable) && downloadUrl ? (
                            <a
                                href={downloadUrl}
                                className="btn btn-download"
                                target="_blank"
                                title="Download"
                                onClick={this.onClickDownload}
                            >
                                <span className="fa fa-download" />
                            </a>
                        ) : null }
                        <button
                            type="button"
                            className="btn btn-share"
                            onClick={this.onClickShare}
                            title="Share"
                        >
                            <span className="fa fa-share" />
                        </button>
                    </div>
                ) : null }

                { shareOpened ? this.renderShare() : null }
            </div>
        );
    }
}

ImageBlock.propTypes = propTypes;
ImageBlock.defaultProps = defaultProps;
ImageBlock.blockDefinition = blockDefinition;

export default ImageBlock;



// WEBPACK FOOTER //
// ./components/blocks/Image.jsx